import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
    container: {
        paddingHorizontal: 25,
        marginTop: 20
    },
    title: {
        textAlign: 'center',
        fontSize: 16,
        fontWeight: 'bold',
        marginTop: 5
    },
    contentImgsCoins: {
        flexDirection: 'row',
        justifyContent: 'space-around',
        marginTop: 28
    },
    imgCoins: {
        width: 50,
        height: 50,
        borderRadius: 25,
        borderWidth: 2,
        borderColor: '#1FBFB5'
    },
    contentPrice: {
        paddingHorizontal: 25,
        marginTop: 10,
        textAlign: 'center'
    },
    textPriceLeft: {
        fontSize: 16
    },
    textPriceRight: {
        fontSize: 16,
        textAlign: 'right'
    },
    price: {
        fontSize: 16,
        fontWeight: 'bold',
        textAlign: 'center'
    },
    priceSecondary: {
        fontSize: 14,
        fontWeight: '400',
        color: '#656565',
        textAlign: 'right'
    },
    hr: {
        height: 1,
        marginTop: 18,
        backgroundColor: "#2C2C2E",
        opacity: 0.5,
    },
    contentCheckbox: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start',
        width: '90%',
        marginTop: 10
    },
    confirmDataRow: {
        paddingHorizontal: 0,
        display: 'flex', 
        flexDirection: 'row'
    },
    confirmDataRowColTitle: {
        flex: 0.5, 
        fontWeight: '700', 
        fontSize: 16, 
        color: '#333333'
    },
    confirmDataRowColText: {
        flex: 0.5, 
        fontWeight: '400', 
        fontSize: 16, 
        color: '#656565', 
        textAlign: 'right'
    },
    contentBtn: {
        position: 'absolute',
        bottom: 50,
        paddingHorizontal: 25,
        width: '100%'
    },
    btn: {
        padding: 10,
        borderRadius: 20
    },
    textBtn: {
        color: '#fff',
        textAlign: 'center',
        fontSize: 18,
        fontWeight: '500'
    }
});

export default styles;
